export default __webpack_public_path__ + "static/media/whitegoose14.e261861d.jpg";